import axios from "axios";

export class ModerationNotifier {
	private readonly container: JQuery;

	constructor(containerId: DOMElementIdentifier, private constructionParameters: ConstructionParameters) {
		this.container = jQuery("#" + containerId);
		jQuery(document).ready(() => void this.onDocumentReady());
	}

	private async onDocumentReady(): Promise<void> {
		const response = await axios.get(this.constructionParameters.countDiscussionItemsUrl);
		this.onCount(response.data);
	}

	private onCount(data: any) {
		if (data.count !== 0) {
			this.container.removeClass("hidden");
			this.container.text(data.message);
		}
	}
}
